module.exports = __webpack_public_path__ + "img/main_desktop.09908966.webp";